import { Component, OnInit, ViewChild, ElementRef, Input, Renderer2 } from '@angular/core';

@Component({
  selector: 'lib-small-triangle',
  templateUrl: './small-triangle.component.html',
  styleUrls: ['./small-triangle.component.scss']
})
export class SmallTriangleComponent implements OnInit {


  @ViewChild('smallTriangleWarehouse', { static: true })
  smallTriangleWarehouse!: ElementRef;

  @Input() height!: string;

  constructor(private renderer: Renderer2) { }

  ngOnInit(): void {

    if (this.height) {
      this.renderer.setStyle(this.smallTriangleWarehouse.nativeElement, 'height', this.height);
    }
  }

}
